import React, { Component } from "react";
import "./App.css";
import "./wheel.css";
import Swal from "sweetalert2";
import instance from "./axios-instance";
import Systems from "./SystemFunction";
class App extends Component {
  get lang() { return localStorage.getItem('lang') || 'th'; }
  constructor(props) {
    super(props);

    this.state = {
      point: props.point || 0,
      userid: props.userid || "",
      remaining_amount: 0,
      tblwheelsetting: [],

      currentPosition: 0,
      isSpinning: false,

      wheelLogo:
        "https://s3.newworld.center/image/3e24f61d-c4cc-4653-a413-ca57dc847f69.webp",

      tabselect: 0,
      segColors: [],
      segments: [],
    };
  }

  componentDidMount() {
    this.getwheel();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.point !== this.props.point) {
      this.setState({
        point: this.props.point || 0,
      });
    }

    if (prevProps.userid !== this.props.userid) {
      this.setState({
        userid: this.props.userid || "",
      });
    }
  }

  handleNav(to, e = { preventDefault: () => { } }) {
    // ถ้า e ถูกส่งมาจาก onClick ปกติ
    if (e?.preventDefault) e.preventDefault();

    // รองรับ ctrl / alt / middle click
    if (e?.metaKey || e?.ctrlKey || e?.shiftKey || e?.altKey || e?.button === 1) return;

    console.log("📍 Navigate to:", to);

    if (typeof this.props.onNavigate === "function") {
      this.props.onNavigate(to, e);
    } else {
      // fallback
      window.history.pushState(null, "", to);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }

  playSound = (id, stop = 6500) => {
    const audio = document.getElementById(id);
    if (!audio) return;

    audio.currentTime = 0;
    audio.play().catch(() => { });

    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
    }, stop);
  };

getwheel = async () => {
  try {
    const res = await instance.post("/api/v1/getwheelspin", {
      System: Systems,
    });

    console.log("[WHEEL:GET]", res.data);

    if (res.data.status !== 200) return;

    let datas = res.data.message || [];
    const tblwheelsetting = res.data.tblwheelsetting || [];

    // ยังไม่ได้ตั้งรางวัลกงล้อในระบบหลังบ้าน → โชว์ชุดตัวอย่างให้เห็นว่ากงล้อทำงาน
    let isDemo = false;
    if (datas.length === 0) {
      isDemo = true;
      datas = [
        { id: 1, description: '5 บาท' }, { id: 2, description: '10 บาท' }, { id: 3, description: '20 บาท' },
        { id: 4, description: '50 บาท' }, { id: 5, description: '100 บาท' }, { id: 6, description: 'ลุ้นใหม่' },
        { id: 7, description: '300 บาท' }, { id: 8, description: '500 บาท' },
      ];
    }

    if (!isDemo && tblwheelsetting.length > 0 && Number(tblwheelsetting[0].status) === 0) {
      await Swal.fire({
        icon: "error",
        title: 'เกมยังไม่เปิดให้บริการ',
        showConfirmButton: true,
        confirmButtonText: 'ตกลง',
      });

      this.handleNav("/");
      return;
    }

    // ✅ ใส่เลขช่องที่ต้องการให้เป็น “สีส้ม” ตรงนี้
    // index เริ่มจาก 0
    // ตัวอย่าง: ช่องที่ 1 และช่องที่ 4 เป็นสีส้ม
    const orangeIndexes = [9, 4];

    const segments = datas.map((item, index) => ({
      id: item.id ?? index,
      name: item.description || item.name || "",
      image: item.image || "",
      colorType: orangeIndexes.includes(index)
        ? "orange"
        : index % 2 === 0
          ? "dark1"
          : "dark2",
    }));

    this.setState({
      tblwheelsetting,
      segments,
      segColors: [],
      isDemo,
    });
  } catch (error) {
    console.log("[WHEEL:GET_ERROR]", error);
  }
};
getWheelBackground = () => {
  const { segments } = this.state;

  if (!segments || !segments.length) return "#050505";

  const total = segments.length;
  const sliceDeg = 360 / total;

  const getStops = (type, start, end) => {
    const mid = start + (end - start) / 2;

    // ✅ สีส้ม ตั้งแต่ render
    if (type === "orange") {
return `
  #ff6a00 ${start}deg,
  #ff6a00 ${end}deg
`;
    }

    // ✅ สีทอง เฉพาะช่องที่ถูกรางวัล หลังหมุนจบ
    if (type === "winner") {
      return `
     #ffffff ${start}deg,
  #ffe45c ${start + sliceDeg * 0.18}deg,
  #ffb300 ${mid}deg,
  #ffd84d ${end - sliceDeg * 0.18}deg,
  #fffdf5 ${end}deg
      `;
    }

    if (type === "dark1") {
      return `
        #020202 ${start}deg,
        #101010 ${mid}deg,
        #020202 ${end}deg
      `;
    }

    return `
      #111111 ${start}deg,
      #242424 ${mid}deg,
      #0b0b0b ${end}deg
    `;
  };

  return `conic-gradient(from -90deg,
    ${segments
      .map((item, index) => {
        const start = sliceDeg * index;
        const end = sliceDeg * (index + 1);
        return getStops(item.colorType, start, end);
      })
      .join(",")}
  )`;
};

  // spinWheel
spinWheel = (reward, rewardKey, eventBalance) => {
  const orangeIndexes = [9, 4]; // ✅ ช่องสีส้ม ใส่เลขตรงนี้

  const resetSegments = this.state.segments.map((item, index) => ({
    ...item,
    colorType:
      orangeIndexes.includes(index)
        ? "orange"
        : index % 2 === 0
          ? "dark1"
          : "dark2",
  }));

  const total = resetSegments.length;

  if (!total) {
    this.setState({ isSpinning: false });
    return;
  }

  const sliceDeg = 360 / total;

  let rewardIndex = resetSegments.findIndex(
    (item) => String(item.id) === String(reward?.id)
  );

  if (rewardIndex < 0 && rewardKey !== undefined && rewardKey !== null) {
    rewardIndex = Number(rewardKey) - 1;
  }

  if (rewardIndex < 0 || rewardIndex >= total) {
    this.setState({ isSpinning: false });
    return;
  }

  const baseSpin = 6 * 360;
  const targetAngle = rewardIndex * sliceDeg + sliceDeg / 2;

const currentBase = Number(this.state.currentPosition) || 0;
const currentMod = ((currentBase % 360) + 360) % 360;

const pointerOffset = 90; // ลูกศรอยู่ด้านบน
const needRotate =
  (360 - ((targetAngle + currentMod - pointerOffset + 360) % 360)) % 360;

const nextPosition = currentBase + baseSpin + needRotate;

  // ✅ ตรงนี้คือเคลียร์ winner เก่าออกทันทีตอนเริ่มหมุน
  this.setState({
    segments: resetSegments,
    currentPosition: nextPosition,
    isSpinning: true,
    point: eventBalance,
  });

  setTimeout(() => {
    const finalSegments = resetSegments.map((item, index) => ({
      ...item,
      colorType: index === rewardIndex ? "winner" : item.colorType,
    }));

    this.setState({
      segments: finalSegments,
      currentPosition: nextPosition,
      isSpinning: false,
      point: eventBalance,
    });

   Swal.fire({
  icon: "success",
  title: 'ขอแสดงความยินดี',
  text: reward?.description || reward?.name || "",
  imageUrl: reward?.image || "",
  imageWidth: window.innerWidth <= 768 ? 120 : 180,
  imageHeight: window.innerWidth <= 768 ? 120 : 180,
  confirmButtonText: 'ตกลง',
  customClass: {
    popup: "wheel-reward-popup",
    image: "wheel-reward-popup-image"
  }
});
  }, 7200);
};
  handleSpinWheel = async (e) => {
    if (e) e.preventDefault();

    if (this.state.isSpinning) return;

    if (this.state.point <= 0) {
      await Swal.fire({
        icon: "warning",
        title: 'ตั๋วไม่พอ',
        text: 'คุณไม่มีตั๋วสำหรับหมุนกงล้อ',
        confirmButtonText: 'ตกลง',
      });
      return;
    }

    const token = localStorage.getItem("auth_token");

    if (!token) {
      await Swal.fire({
        icon: "warning",
        title: 'กรุณาเข้าสู่ระบบ',
        confirmButtonText: 'ตกลง',
      });

      this.handleNav("/login");
      return;
    }

    this.setState({
      isSpinning: true,
    });

    try {
      const res = await instance.post("/api/v1/postwheelspin", {
        token,
        System: Systems,
      });

      console.log("[WHEEL:SPIN]", res.data);

      const rewardKey = res.data.reward_key;
      const eventBalance = res.data.event_balance;
      const reward = res.data.reward;

      if (!reward) {
        throw new Error("Reward not found");
      }

      this.spinWheel(reward, rewardKey, eventBalance);
    } catch (err) {
      console.log("[WHEEL:SPIN_ERROR]", err);

      this.setState({
        isSpinning: false,
      });

      await Swal.fire({
        icon: "error",
        title: 'หมุนกงล้อไม่สำเร็จ',
        text: 'กรุณาลองใหม่อีกครั้ง',
        confirmButtonText: 'ตกลง',
      });
    }
  };

renderWheelItems = () => {
  const { segments } = this.state;

  if (!segments || !segments.length) return null;

  const total = segments.length;
  const sliceDeg = 360 / total;

  const isMobile = window.innerWidth <= 768;

  // วงล้อในแอป GRAND กว้างคงที่แบบมือถือ (~170px) ไม่ว่าจะเปิดบนเดสก์ท็อปหรือไม่
  // จึงใช้รัศมี/ความกว้างป้ายแบบมือถือเสมอ (ของเดิม isMobile=false บนเดสก์ท็อปทำให้ป้ายหลุดออกนอกวง)
  const labelRadius = -100;
  const labelWidth = 54;

  return segments.map((item, index) => {
    const angle = -90 + sliceDeg * index + sliceDeg / 2;

    return (
      <div
        key={`${item.id}_${index}`}
        className={`wheel-label ${item.colorType === "winner" ? "winner" : ""}`}
        style={{
          width: `${labelWidth}px`,
          transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(${labelRadius}px) rotate(${-angle}deg)`
        }}
      >
        {item.image ? (
          <img src={item.image} className="wheel-prize-img" alt="" />
        ) : null}

        <div className="wheel-prize-text">{item.name}</div>
      </div>
    );
  });
};

  render() {
    const {
      tabselect,
      segments,
      currentPosition,
      wheelLogo,
      point,
      isSpinning,
      remaining_amount,
      tblwheelsetting,
    } = this.state;

    const wheelAmount =
      tblwheelsetting.length > 0 ? Number(tblwheelsetting[0].amount) || 0 : 0;

    const progressWidth =
      wheelAmount > 0 ? `${(remaining_amount / wheelAmount) * 100}%` : "0%";

    return (
      <>

        <div className="col-12 p-0 mx-auto my-auto text-white-v1 wheel-page-col">
          <div className="wheel-topbar text-center bg-title-web">
            <div className="text-title text-white-v1 text-center">
              <div className="d-flex justify-content-between">
                <div className="text-white-v1-deposit">
                  <a role="button" onClick={(e) => this.handleNav("/", e)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={25}
                      height={25}
                      fill="currentColor"
                      className="bi bi-arrow-left-circle text-color-back"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                      />
                    </svg>
                  </a>
                </div>

                <div className="text-white-v1-deposit">
                  <h5>{'กิจกรรมกงล้อ'}</h5>
                </div>

                <div className="text-white-v1-deposit">
                  <h5 role="button" className="text-title-navbar">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={20}
                      height={20}
                      fill="currentColor"
                      className="text-white-v1-deposit bi bi-card-list"
                      viewBox="0 0 16 16"
                    >
                      <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                      <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                    </svg>
                  </h5>
                </div>
              </div>

              <hr className="mt-0" />
            </div>
          </div>

          <div className="wheel-page-body -full-flex-wrap">
            <div
              className="-full-flex-inner-bg -bg"
              style={{
                backgroundImage:
                  "url(/build/web/igame-index-lobby-wm/img/index-bg.jpg?v=1)",
              }}
            >
              <div
                className="wheel-section x-lucky-wheel-share-component x-bg-position-center lazyloaded"
                style={{
                  backgroundImage:
                    'url("/build/web/igame-index-lobby-wm/img/wheel-page-bg.jpg?v=1")',
                }}
              >
                <div className="wheel-title text-center mb-4">
                  <h1 className="-heading-title animated fadeInUp">
                    {'กงล้อพารวย'}
                  </h1>
                </div>

                <div className="wheel-main-container container">
                  <div className="wheel-frame-stage animated fadeInUp">
                    <div className="wheel-frame-title">
                      {'ปั่นกงล้อสุ่มรับรางวัล ได้ทุกวัน'}
                    </div>

                <div className="wheel-art-wrap">
  <div
    id="wheelSpinner"
    className="wheel-dynamic-spinner"
    style={{
      "--wheel-count": segments?.length || 10,
      background: this.getWheelBackground(),
      transform: `translate(-50%, -50%) rotate(${currentPosition || 0}deg)`
    }}
  >
    {this.renderWheelItems()}

    <div className="wheel-center-logo">
      <img src={wheelLogo} alt="logo" />
    </div>
  </div>

  <img
    src="https://s3.newworld.center/image/bdd52851-8d95-4cfc-9123-bfcc0e452d31.webp"
    className="wheel-frame-bg"
    alt="wheel frame"
  />

  <button
    type="button"
    onClick={this.handleSpinWheel}
    disabled={isSpinning || point <= 0}
    className="wheel-spin-button"
  >
    {isSpinning ? <i className="fas fa-spinner fa-spin" style={{ marginRight: 6 }} /> : null}
    {isSpinning ? 'กำลังหมุน...' : "SPIN!"}
  </button>

  <div className="wheel-ticket-box">
    <span className="wheel-ticket-label">{'ตั๋วคงเหลือ'}</span>
    <img
      src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-ticket.png"
      alt="ticket"
      className="wheel-ticket-icon"
    />
    <span className="wheel-ticket-count">{point}</span>
  </div>
</div>
                  </div>

                  <button
                    type="button"
                    onClick={this.handleSpinWheel}
                    className={
                      point > 0 && !isSpinning
                        ? "btn -btn-spin js-wheel-button animated fadeInUp"
                        : "btn -btn-spin js-wheel-button disabled animated fadeInUp"
                    }
                    disabled={point <= 0 || isSpinning}
                  >
                    <span className="-text">
                      {isSpinning ? 'กำลังหมุน...' : 'หมุนกงล้อ'}
                    </span>

                    <img
                      alt="ticket"
                      className="img-fluid"
                      width={30}
                      height={30}
                      src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-ticket.png"
                    />

                    <span className="-text js-spin-ticket">{point}</span>
                  </button>

                  <audio
                    id="sfx-wheel-spinning"
                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/sfx-wheel-spinning.mp3"
                  />

                  <audio
                    id="sfx-wheel-got-reward"
                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/sfx-wheel-got-reward.mp3"
                  />
                </div>

                <div className="x-wheel-progress-wrapper">
                  <div className="container">
                    <div className="-inner-wrapper animated fadeInUp">
                      <div>
                        {'ฝากเงินสะสม'} {wheelAmount} {'บาท ได้ 1 ตั๋ว'}
                      </div>

                      <div className="progress -progress mt-2">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{ width: progressWidth }}
                          aria-valuenow={0}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        />

                        <span className="-label">
                          {remaining_amount}/{wheelAmount}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="x-modal modal"
                id="luckyWheelConditionModal"
                tabIndex={-1}
                role="dialog"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-medium"
                  role="document"
                >
                  <div className="modal-content -modal-content">
                    <button
                      type="button"
                      className="close f-1"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <i className="fas fa-times" />
                    </button>

                    <div className="modal-header -modal-header">
                      <h3 className="x-title-modal d-inline-block m-auto">
                        {'เงื่อนไขการให้บริการ'}
                      </h3>
                    </div>

                    <div className="modal-body -modal-body">
                      <div className="x-lucky-wheel-condition-container">
                        <p>
                          {'• ฝากเงินสะสมครบ 1,000 บาท จะได้รับ 1 ตั๋ว (สูงสุด 5 ตั๋ว / วัน)'}
                          <br />
                          {'• ยอดฝากสะสมจะ '}{" "}
                          <span style={{ color: "#f39c12" }}>
                            <u>
                              <strong>{'รีเซ็ตเป็น 0'}</strong>
                            </u>
                          </span>{" "}
                          {' ในเวลา 00.00 น. ของทุกวัน'}
                        </p>

                        <p>
                          <span style={{ color: "#e74c3c" }}>
                            {'*ตั๋วกงล้อจะถูกคำนวณและได้รับ ต่อเมื่อเข้ามาที่หน้านี้เท่านั้น หากไม่เข้าจะไม่ได้รับ'}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="x-modal modal"
                id="luckyWheelResultModal"
                tabIndex={-1}
                role="dialog"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable"
                  role="document"
                >
                  <div className="modal-content -modal-content">
                    <div className="modal-header -modal-header">
                      <h3 className="x-title-modal d-inline-block m-auto">
                        {'ขอแสดงความยินดี'}
                      </h3>
                    </div>

                    <div className="modal-body -modal-body">
                      <div className="x-wheel-result-modal-container">
                        <p className="js-modal-wheel-result-description -description" />

                        <div className="-reward-image-wrapper">
                          <img
                            alt="effect"
                            className="-img-bg img-fluid"
                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-reward-effect-bg.png"
                          />

                          <img
                            src=""
                            alt="reward"
                            className="js-modal-wheel-result-image -img img-fluid"
                          />
                        </div>

                        <button
                          type="button"
                          className="btn -btn-close-modal"
                          data-dismiss="modal"
                        >
                          {'ปิด'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default App;